import React from "react";
import { Trans, useTranslation } from "react-i18next";

export default function ExamplePlayer() {
    const { t, i18n } = useTranslation();

    return (
        <div>
            <h2>
                <Trans i18nKey="example_audio.title" />
            </h2>
            <label>
                <Trans i18nKey="example_audio.transcript" />
            </label>
            <audio
                src="https://54696d21.github.io/esperantoTTS/example1.mp3"
                autostart="false"
                controls
                name="media"
                preload="true"
            />
        </div>
    );
}
